<app-wait-container [style]="'overflow-x: clip'" [loading]="loading">
    <ng-container *ngIf="!loading">
        <div class="grid">
            <div class="col-12 lg:col-8 left-panel">
                <p-message *ngIf="!anyWorkflows" class="mt-2" severity="info" [text]="app.t('wfs.noWorkflows')"></p-message>
                <ng-container *ngFor="let inbox of inbox.inboxes">
                    <p-panel *ngIf="inboxTables[inbox.id].rows.length > 0" styleClass="mb-2" [header]="inbox.title">
                        <sm-table2 [data]="inboxTables[inbox.id]" [autoHeight]=true (onRowSelect)="selectRow($event)">
                        </sm-table2>
                    </p-panel>
                </ng-container>
            </div>
            <div class="col-12 lg:col-4 flex-col gap-1">
                @if (!fd || personell.length > 0) {
                    <p-panel [header]="app.t('wfs.state.title')">
                        <app-sm-switch [textFalse]="app.t('wfs.state.no')" [textTrue]="app.t('wfs.state.yes')" [(value)]="atWork" (valueChange)="changeAtWork()"></app-sm-switch>
                        @if (fd && !atWork && substituteDuringAbsence != null && !setAbsentInProgress) {
                            <div class="width100p text-center">Vertreter: {{substituteDuringAbsence.lastName}}, {{substituteDuringAbsence.firstName}}</div>
                        }
                    </p-panel>
                }
                @if (fd) {
                    <p-panel [header]="app.t('customers.formeld.vacationAccount')">
                        <b>{{thisYear}}</b>
                        {{app.t('customers.formeld.vacationEntitlement')}}: 
                        <b>{{personellFile.getNumberByInternal("UrlaubsanspruchaktuellesJahr") | number:'1.0-2'}}</b>
                        {{app.t('customers.formeld.vacationRemaining')}}: 
                        <b>{{personellFile.getNumberByInternal("UrlaubsanspruchaktuellesJahr") - personellFile.getNumberByInternal("UrlaubsanspruchTageaktuellesJahr") | number:'1.0-2'}}</b>
                        @if (personellFile.getNumberByInternal("UrlaubsanspruchFolgejahr") > 0) {
                            <br>
                            <b>{{thisYear + 1}} </b>{{app.t('customers.formeld.vacationEntitlement')}}: 
                            <b>{{personellFile.getNumberByInternal("UrlaubsanspruchFolgejahr") | number:'1.0-2'}}</b>
                            {{app.t('customers.formeld.vacationRemaining')}}: 
                            <b>{{personellFile.getNumberByInternal("UrlaubsanspruchFolgejahr") - personellFile.getNumberByInternal("UrlaubsanspruchTageFolgejahr") | number:'1.0-2'}}</b>
                        }
                        <div class="mt-2">
                            <p-messages severity="warn">
                                <ng-template pTemplate>
                                    <div class="vacation-days-note" [innerHTML]="app.t('customers.formeld.vacationDaysNote')">
                                    </div>
                                </ng-template>
                            </p-messages>
                        </div>
                    </p-panel>
                    <p-panel [header]="app.t('wfs.startWorkflow')">
                        <ul>
                            <li *ngFor="let startable of startables"><a href=# (click)="startWorkflow(startable); $event.preventDefault()">{{app.t('wfs.families.' + startable.instanceName + '.name', null, startable.instanceName)}}</a></li>
                        </ul>
                    </p-panel>
                    <p-panel [header]="app.t('customers.formeld.personellFile.title')">
                        <div class="flex-row flex-wrap gap-2">
                            <p-button icon="fas fa-user" [label]="app.t('customers.formeld.personellFile.open')" (onClick)="openPersonellFile()">
                            </p-button>
                            <p-button icon="fas fa-virus" [label]="app.t('customers.formeld.addSickNote.title')" (onClick)="addSickNote()">
                            </p-button>
                            <p-button *ngIf="personell.length > 0" icon="fas fa-calendar-day" [label]="app.t('customers.formeld.addCompensationDay.title')" (onClick)="addCompensationDay()">
                            </p-button>
                        </div>
                    </p-panel>
                }
            </div>
        </div>
    </ng-container>
</app-wait-container>
